export default __webpack_public_path__ + "static/media/icons-hamburger.3db5da7b.svg";